import {DocumentTopic, DocumentTopicRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import React from "react";

// Temas con los que se agrupan los documentos de empresa en el portal del empleado (#13729).
export const DocumentTopicListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<DocumentTopic> = {
		title: "Temas de documentos",
		onClick: "/app/admin/compliance/documenttopic",
		headers: [
			{title: "Orden", width: 90, align: "right"},
			{title: "Nombre"},
		],
		decorator: (bean: DocumentTopic) => (
			<>
				<TableCell align="right" sx={{fontVariantNumeric: "tabular-nums", color: "text.secondary"}}>{bean.position}</TableCell>
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>{bean.name}</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(DocumentTopicRestControllerApiFactory);
			return ctrl.pageDocumentTopic(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};
